import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/campaign/reducers'
import { getInitialState } from 'store/features/campaign/initialState'

const campaignSlice = createSlice({
  name: 'campaign',
  initialState: getInitialState(),
  reducers
})

export default campaignSlice
